<template>
    <TopBar v-if="showStepper" @openScoringPanel="openScoringPanel" />
    
    <StepperProgress v-if="showStepper" />
    
    <div>
        <h1 :class="['heading', headerAlignment]">{{ heading }}</h1>
    </div>

    <ScoringPanel 
        v-if="isScoringPanelOpen"
        :isOpen="isScoringPanelOpen" 
        :totalScore="totalScore" 
        :casiATT="casiATT"
        :casiMMC="casiMMC"
        :casiORI="casiORI"
        :casiLTM="casiLTM"
        :casiSTM="casiSTM"
        :casiLANG="casiLANG"
        :casiDRAW="casiDRAW"
        :casiFLU="casiFLU"
        :casiATAJ="casiATAJ"
        :panelWidth="panelWidth"
        @close="closeScoringPanel"
        @resize="handleResize"
    />
</template>

<script>
import ScoringPanel from '../components/ScoringPanel.vue';
import TopBar from '../components/TopBar.vue';
import StepperProgress from '../components/StepperProgress.vue';

export default {
    components: {
        ScoringPanel,
        TopBar,
        StepperProgress
    },
    props: {
        heading: {
            type: String,
            required: true
        },
        headerAlignment: {
            type: String,
            default: 'left'
        },
        ...['totalScore', 'casiATT', 'casiMMC', 'casiORI', 'casiLTM', 'casiSTM', 'casiLANG', 'casiDRAW', 'casiFLU', 'casiATAJ'].reduce((acc, key) => {
            acc[key] = { type: Number, default: 0 };
            return acc;
        }, {})
    },
    data() {
        return {
            isScoringPanelOpen: false,
            panelWidth: 775,
        };
    },
    computed: {
        showStepper() {
            return this.$route.path !== '/';
        }
    },
    watch: {
        isScoringPanelOpen(newVal) {
            const app = document.getElementById('app');
            if (app) {
                if (newVal) {
                    app.style.maxWidth = `calc(100vw - ${this.panelWidth}px - 20px)`;
                    app.style.marginRight = `${this.panelWidth}px`;
                    app.style.marginLeft = '20px';
                    app.style.transition = 'max-width 0.3s ease, margin-right 0.3s ease, margin-left 0.3s ease';
                    document.body.style.overflow = 'hidden';
                } else {
                    app.style.maxWidth = '1200px';
                    app.style.marginRight = 'auto';
                    app.style.marginLeft = 'auto';
                    document.body.style.overflow = '';
                }
            }
        },
        panelWidth(newWidth) {
            const app = document.getElementById('app');
            if (app && this.isScoringPanelOpen) {
                app.style.maxWidth = `calc(100vw - ${newWidth}px - 20px)`;
                app.style.marginRight = `${newWidth}px`;
                app.style.marginLeft = '20px';
            }
        }
    },
    methods: {
        openScoringPanel() {
            this.isScoringPanelOpen = true;
        },
        closeScoringPanel() {
            this.isScoringPanelOpen = false;
        },
        handleResize(newWidth) {
            this.panelWidth = newWidth;
        }
    },
    beforeUnmount() {
        const app = document.getElementById('app');
        if (app) {
            app.style.maxWidth = '1200px';
            app.style.marginRight = 'auto';
            app.style.marginLeft = 'auto';
        }
        document.body.style.overflow = '';
    }
}
</script>

<style scoped>

.heading {
    font-weight: normal;
    font-size: 36px;
    margin-bottom: 30px;
    color: #237091;
}
.heading.left {
    text-align: left;
}
.heading.center {
    text-align: center;
}
.instructions {
    font-size: 20px;
    line-height: 1.5;
}
.arrow-buttons-container {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
}
</style>
